module.exports = __webpack_public_path__ + "static/img/card4.8d37185b.png";